import ApiConstants from '../../constants/ApiConstants';
import xhr from './xhr';

const TutorDataApiUtils = {
  fetchIssueRate() {
    return xhr(ApiConstants.Base + 'tutor-data/issue-rate');
  },
  fetchSubscribeRate() {
    return xhr(ApiConstants.Base + 'tutor-data/subscribe-rate');
  },
};

export default TutorDataApiUtils;
